import React, { useEffect } from 'react';
import { UpcomingEvents } from './UpcomingEventsLanding';
import { Box, Flex, Heading, Button, Icon } from '@spothero/ui';
import X from '@spothero/icons/x';
import { useSelector } from 'react-redux';
import StorageUtils from '@spothero/utils/storage';
import SegmentUtils from 'utils/segment';
import { NotGoingToEvent } from '../not-going-to-event/NotGoingToEvent';
import UrlUtils from '@spothero/utils/url';
import { showSearch } from '../utils';
export const VenueEventSEMEdit = () => {
    const title = useSelector((state) => state.destination.data.title);
    const searchString = useSelector((state) => state.searchRequest.search_string);
    const partner = useSelector((state) => state.searchRequest.partner);
    const destinationId = useSelector((state) => state.destination.data.id);
    const queryParams = UrlUtils.parseParams(window.location.search);
    const handleCloseClick = () => {
        showSearch({ destinationId, queryParams });
    };
    useEffect(() => {
        const userLatLng = StorageUtils.get('sh-user-location', 'session');
        SegmentUtils.track({
            event: 'Event List Display',
            properties: {
                /* eslint-disable camelcase */
                ...(userLatLng && { user_location: userLatLng }),
                ...(searchString && { search_query: searchString }),
                destination: title,
                /* eslint-enable camelcase */
            },
        });
    }, [searchString, title]);
    const beforeTitleText = partner === 'apple'
        ? 'Book Parking for '
        : 'Find parking for events near ';
    return (<Flex paddingX="4" data-testid="VenueEventSEMEdit" width="100%" flexDirection="column" flexGrow="1">
            <Flex>
                <Heading as="h3" paddingBottom="2" paddingTop={2}>
                    {beforeTitleText}
                    {title}
                </Heading>
                <Button variant="tertiary" color="black" onClick={handleCloseClick} right="0" height="100%" data-testid="VenueEventLandingEdit-close-button" aria-label="Close" tabIndex={-1} // Prevents focus from being set on the button when modal opens
    >
                    <Icon as={X} height="4.5" width="4.5"/>
                </Button>
            </Flex>
            <Flex flex="1" overflowY="auto" marginY="2">
                <UpcomingEvents />
            </Flex>
            <Box flex="0 0 auto" textAlign="center">
                <NotGoingToEvent />
            </Box>
        </Flex>);
};
